import { absolutePath } from "./absolutePath";

interface CommunityMemberChargeFnProps {
  chargeId?: string | number;
  params?: Record<string, unknown>;
}

export const communityMemberCharge = {
  index: ({ params = {} }: CommunityMemberChargeFnProps = {}) =>
    absolutePath("community_member_charges", params),
  invoice: {
    show: ({ chargeId }: CommunityMemberChargeFnProps) =>
      absolutePath(`community_member_charges/invoices/${chargeId}`),
  },
};
